import React from 'react';
import { X } from 'phosphor-react';
import './SDialog.css';

interface SDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  height?: string;
}

const SDialog: React.FC<SDialogProps> = ({
  isOpen,
  onClose,
  title,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  children,
  height,
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <>
      <div
        className={`s-dialog-overlay ${isOpen ? 'open' : ''}`}
        onClick={handleOverlayClick}
      />
      <div
        className={`s-dialog ${isOpen ? 'open' : ''}`}
        style={height ? { height } : undefined}
      >
        {/* Handle */}
        <div className="s-dialog-handle" />

        {/* Header */}
        <div className="s-dialog-header">
          <span className="s-dialog-title">{title}</span>
          <button className="s-dialog-close" onClick={onClose} aria-label="Close">
            <X size={16} color="#6b6860" weight="bold" />
          </button>
        </div>

        {/* Content */}
        {children && (
          <div className="s-dialog-content">{children}</div>
        )}

        {/* Actions */}
        <div className="s-dialog-actions">
          <button className="s-dialog-btn s-dialog-btn--ghost" onClick={onClose}>
            {cancelText}
          </button>
          <button className="s-dialog-btn s-dialog-btn--primary" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
};

export default SDialog;
